import _ from 'lodash';
import ah from '../utils/ajax-helper';

var addStartTime = function addStartTime(date) {
  return date.split(' ')[0] + ' 00:00:00';
};

var addEndTime = function addEndTime(date) {
  return date.split(' ')[0] + ' 23:59:59';
}; // 1.


export var getMapeZoneVisitByWeek = function getMapeZoneVisitByWeek(contextRoot, noProgress, dateRange, predSeq, terminalId) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      terminalId: terminalId
    };
    ah.get("".concat(contextRoot, "/mape/zone-visit/by/week"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getMapeZoneVisitByTerminal = function getMapeZoneVisitByTerminal(contextRoot, noProgress, dateRange, predSeq) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      terminalId: ''
    };
    ah.get("".concat(contextRoot, "/mape/zone-visit/by/terminal"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 2.
// gate to gate list 

export var getMapeIttGateToGateList = function getMapeIttGateToGateList(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/mape/itt/gate-to-gate/list"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // gate to gate mape

export var getMapeIttByGateToGate = function getMapeIttByGateToGate(contextRoot, noProgress, dateRange, predSeq, oriGateId, dstGateId) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      oriGateId: oriGateId,
      dstGateId: dstGateId
    };
    ah.get("".concat(contextRoot, "/mape/itt/by/gate-to-gate"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getMapeIttByWeek = function getMapeIttByWeek(contextRoot, noProgress, dateRange, predSeq, oriGateId, dstGateId) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      oriGateId: oriGateId,
      dstGateId: dstGateId
    };
    ah.get("".concat(contextRoot, "/mape/itt/by/week"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 時間區間內貨櫃中心查驗站組合車輛數 GROUP BY WEEK

export var getMapeIttVehicleVolumesByWeek = function getMapeIttVehicleVolumesByWeek(contextRoot, noProgress, dateRange, predSeq, oriGateId, dstGateId) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      oriGateId: oriGateId,
      dstGateId: dstGateId
    };
    ah.get("".concat(contextRoot, "/mape/itt/vehicle-volumes/by/week"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // Vehicle Volumes By Gate To Gate

export var getMapeIttVehicleVolumesByGateToGate = function getMapeIttVehicleVolumesByGateToGate(contextRoot, noProgress, dateRange, predSeq, oriGateId, dstGateId) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      oriGateId: oriGateId,
      dstGateId: dstGateId
    };
    ah.get("".concat(contextRoot, "/mape/itt/vehicle-volumes/by/gate-to-gate"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 3.

export var getMapeTerminalLineByWeek = function getMapeTerminalLineByWeek(contextRoot, noProgress, dateRange, predSeq, terminalId, deliverType) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      terminalId: terminalId,
      deliverType: deliverType
    };
    ah.get("".concat(contextRoot, "/mape/terminal-line/by/week"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
export var getMapeTerminalLineByTerminalDeliverType = function getMapeTerminalLineByTerminalDeliverType(contextRoot, noProgress, dateRange, predSeq, terminalId, deliverType) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      terminalId: terminalId,
      deliverType: deliverType
    };
    ah.get("".concat(contextRoot, "/mape/terminal-line/by/terminal-deliverType"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 4
// road-section list 

export var getMapeRoadSectionList = function getMapeRoadSectionList(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/mape/road-section/list"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; /// get road-section by week

export var getMapeRoadSectionByWeek = function getMapeRoadSectionByWeek(contextRoot, noProgress, dateRange, predSeq, roadSectionId) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq,
      'road-section-id': roadSectionId
    };
    ah.get("".concat(contextRoot, "/mape/road-section/by/week"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get mape roadSection by id

export var getMapeRoadSectionById = function getMapeRoadSectionById(contextRoot, noProgress, dateRange, predSeq) {
  return new Promise(function (resolve, reject) {
    var parameters = {
      start: addStartTime(dateRange.from),
      end: addEndTime(dateRange.to),
      predSeq: predSeq
    };
    ah.get("".concat(contextRoot, "/mape/road-section/by/road-section-id"), parameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};